import { getAPIPath, requestGooseAPI } from '../shared/request'
import { APIWaitlistOrderClientDtoResponse, CreateWaitlistOrderClientInput, WaitlistOrderClientDto } from '../types/api'
import { CLIENT_WAITLIST_ORDERS_PATH, CLIENT_WAITLIST_PATH } from '../types/constants'

export interface TClientWaitlistOptions {
  startDate?: string
  endDate?: string
  serviceTypeName?: string
  waitlistStatus?: string
  includes?: string[]
}

export interface TClientWaitlistOptionsForUser {
  serviceTypeName?: string
  waitlistStatus?: string
  limit?: number
  nextToken?: string | null
  includes?: string[]
}

export const ClientWaitListService = {
  create: async (locationName: string, payload: CreateWaitlistOrderClientInput): Promise<WaitlistOrderClientDto> => {
    return requestGooseAPI<WaitlistOrderClientDto>({
      url: getAPIPath(CLIENT_WAITLIST_PATH, { locationId: locationName }),
      method: 'POST',
      data: payload,
    })
  },

  listOrders: async (
    locationName: string,
    options?: TClientWaitlistOptions
  ): Promise<APIWaitlistOrderClientDtoResponse> => {
    const { startDate, endDate, includes, serviceTypeName, waitlistStatus } = options || {}

    const params = { limit: '200' } as Record<string, string | string[] | undefined>
    if (startDate && endDate) {
      params.firstStartDate = `lt_${endDate}`
      params.lastEndDate = `gt_${startDate}`
    }
    if (includes) {
      params.includes = includes
    }
    if (serviceTypeName) {
      params.primaryServiceType = serviceTypeName
    }
    if (waitlistStatus) {
      params.waitlistStatus = waitlistStatus
    }

    return requestGooseAPI<APIWaitlistOrderClientDtoResponse>({
      url: getAPIPath(CLIENT_WAITLIST_ORDERS_PATH, { locationId: locationName }),
      method: 'GET',
      params,
    })
  },

  listOrdersForUser: async (
    locationName: string,
    lupId: string,
    options?: TClientWaitlistOptionsForUser
  ): Promise<APIWaitlistOrderClientDtoResponse> => {
    const { includes, serviceTypeName, waitlistStatus } = options || {}
    const params = {
      limit: options?.limit?.toString() || '50',
      nextToken: options?.nextToken || undefined,
      locationUserProfile: lupId,
    } as Record<string, string | string[] | undefined>

    if (includes) {
      params.includes = includes
    }
    if (serviceTypeName) {
      params.primaryServiceType = serviceTypeName
    }
    if (waitlistStatus) {
      params.waitlistStatus = waitlistStatus
    }

    return requestGooseAPI<APIWaitlistOrderClientDtoResponse>({
      url: getAPIPath(CLIENT_WAITLIST_ORDERS_PATH, { locationId: locationName }),
      method: 'GET',
      params,
    })
  },
}
